module.exports = __webpack_public_path__ + "static/logos-last-b9d506a88f2fc421f2a6199845210791.png";